import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging|Tagging Items|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

export type SPTaggingItemsLocNames =
	| 'SPTaggingItemsTitleTab'
	| 'SPTaggingItemsTitlePage'
	| 'SPTaggingItemsNotificationChangesSaved';

export const spTaggingItemsLocs: LocDefs<SPTaggingItemsLocNames> = {
	SPTaggingItemsTitleTab: {
		defaultValue: 'Tagging Items',
		description: 'Tab title.',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TabTitle.TaggingItems',
		...sharedProperties,
	},
	SPTaggingItemsTitlePage: {
		defaultValue: 'Tagging Items',
		description: 'Page title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.Title.TaggingItems',
		...sharedProperties,
	},
	SPTaggingItemsNotificationChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Notification shown when the item is untagged.',
		displayPath: `${pathStart}Untag Changes Saved`,
		displayType: 'Notification',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.NotificationMessage.Success',
		...sharedProperties,
	},
};

export type SPTaggingItemsLocType = LocMap<SPTaggingItemsLocNames>;
